import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '6a2a0feaa758f939a7b1bd9e';
declare global {
  interface Window {
    pixelId?: string;
  }
}
export function UtmifyPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Avoid double-injecting on re-renders / hot reloads
    if (document.querySelector('script[data-utmify-pixel]')) return;
    window.pixelId = PIXEL_ID;
    const script = document.createElement('script');
    script.setAttribute('async', '');
    script.setAttribute('defer', '');
    script.setAttribute('data-utmify-pixel', PIXEL_ID);
    script.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
    document.head.appendChild(script);
  }, []);
  return null;
}